import rest from '@modules/rest'
import upload from '@modules/upload'
import { getUploadEndpoint, getFileUrl } from '@modules/fileHelpers'
import { ADDRESSES_CONTACTS_AREA } from '@convenia/common-organisms/SystemFields/content/consts'
import { mapCustomFields, mapSystemFields } from '@convenia/employee-organisms/SystemFields/Address/content/mappers'
import * as mappers from '@convenia/common-organisms/SystemFields/content/mappers/address'

export const getAddress = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/addresses/admission`

    const { data } = await rest.get(url)

    const { customFieldValues, ...address } = data || {}

    const mappedAddress = {
      ...mappers.mapAddress(address, { employeeId, getFileUrl }),
      customFieldValues,
    }

    return [ null, mappedAddress ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateAddress = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/addresses/admission`
    const body = mappers.mapAddressInput({ data, schema })

    const response = await rest.post(url, { body, headers: { bcv: true } })

    const { customFieldValues, ...address } = response?.data || {}

    const mappedAddress = {
      ...mappers.mapAddress(address, { employeeId, getFileUrl }),
      customFieldValues,
    }

    return [ null, mappedAddress ]
  } catch (err) {
    return [ err, null ]
  }
}

export const getContacts = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/contact-information/admission`

    const { data } = await rest.get(url)

    const { customFieldValues, ...contacts } = data || {}

    const mappedContacts = {
      ...mappers.mapContacts(contacts, { employeeId, getFileUrl }),
      customFieldValues,
    }

    return [ null, mappedContacts ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateContact = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/contact-information/admission`
    const body = mappers.mapContactInput({
      data,
      schema,
    })

    await rest.post(url, { body })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}

export const getEmergencyContacts = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/emergency-contacts/admission`

    const { data } = await rest.get(url)

    const emergencyContacts = (data || [])
      .map(({ customFieldValues, ...emergencyContact }) => ({
        ...mappers.mapEmergencyContact(emergencyContact, { employeeId, getFileUrl }),
        customFieldValues,
      }))

    return [ null, emergencyContacts ]
  } catch (err) {
    return [ err, null ]
  }
}
export const createEmergencyContact = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/emergency-contacts/admission`
    const body = mappers.mapEmergencyContactInput({ data, schema })

    const response = await rest.post(url, { body })

    const { customFieldValues, ...emergencyContact } = response?.data || {}

    const mappedEmergencyContact = {
      ...mappers.mapEmergencyContact(emergencyContact, { employeeId, getFileUrl }),
      customFieldValues,
    }

    return [ null, mappedEmergencyContact ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateEmergencyContact = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/emergency-contacts/${data.id}/admission`
    const body = mappers.mapEmergencyContactInput({ data, schema, entityId: data?.id })

    await rest.put(url, { body })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}

export const deleteEmergencyContact = async ({ id }, params) => {
  try {
    if (typeof id !== 'string')
      return [ null, null ]

    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/emergency-contacts/${id}/admission`

    await rest.delete(url)

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}
export const getSystemFields = async (params) => {
  const { employeeId, companyId } = params
  const url = `/companies/proxy/companies/${companyId}/employees/${employeeId}/fields/admission`

  try {
    const { data } = await rest.get(url, { params: { area: ADDRESSES_CONTACTS_AREA.LABEL } })
    const fields = data?.sections || []

    const systemFields = mapSystemFields(fields)
    const customFields = mapCustomFields(fields)

    return [ null, { systemFields, customFields } ]
  } catch (err) {
    return [ err, null ]
  }
}

export const uploadAddressFiles = async ({ id, files, employeeId }) => {
  try {
    const endpoint = getUploadEndpoint(employeeId, id, 'address')

    await upload({ files, endpoint })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}
